export * from "@/ui/components/primitives/Illustration/Illustration";
export * from "@/ui/components/primitives/Illustration/Illustration.config";
